export const environment = {
  production: true,
  BASE_DOMAIN:'https://lms-dev.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://lms-dev.apollosupplychain.com/',
  AUTH_URL:'https://auth-dev.apollosupplychain.com/auth-service-common/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://lms-dev.apollosupplychain.com/',
  WebsocketUrl: 'wss://lms-dev.apollosupplychain.com/websocket-service/ws/notifications'
 
  // BASE_DOMAIN:'https://dev.goalfa.in/',
  // New_BASE_DOMAIN:'https://alfa.goalfa.in/',
  // COOKIE_DOMAIN: 'localhost',
  // ORDER_URL: 'https://alfa.goalfa.in/',
  // WebsocketUrl: 'wss://alfa.goalfa.in/websocket-service/ws/notifications'
};
